import { render } from "./ProfileCreationStepCounter.vue?vue&type=template&id=d6c3413e&scoped=true&ts=true"
import script from "./ProfileCreationStepCounter.vue?vue&type=script&lang=ts"
export * from "./ProfileCreationStepCounter.vue?vue&type=script&lang=ts"

import "./ProfileCreationStepCounter.vue?vue&type=style&index=0&id=d6c3413e&scoped=true&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6c3413e"]])

export default __exports__